export function shouldOfferCompleteProjectOnPaid(input: {
  documentType: string;
  nextStatus: string;
  previousStatus: string;
  leadId: string | null | undefined;
}): boolean {
  if (!input.leadId) return false;
  if (input.nextStatus !== 'paid') return false;
  if (input.previousStatus === 'paid') return false;
  return input.documentType === 'invoice' || input.documentType === 'final_invoice';
}
